export default __webpack_public_path__ + "static/media/bg04.9d7db8a1.svg";